import { v4 as uuid } from 'uuid';

export default {
  namespaced: true,

  state: {
    list: null,
    current: null,
  },

  getters: {
    current(state) {
      return state.current;
    },

    list: (state) => state.list,

    get(state) {
      return (id, reload) => {
        let found = null;

        if (state.list) {
          found = state.list.find((i) => i.id === id);
        }

        if (!found || !reload) {
          if (state.current && state.current.id === id) {
            found = state.current;
          }
        }

        return found;
      };
    },
  },

  mutations: {
    bind(state, payload) {
      state.list = payload;
    },

    persist(state) {
      const relationship = state.current;

      if (
        relationship.type !== 'embedded' &&
        relationship.type !== 'many-to-many-explicit'
      ) {
        relationship.embeddedEntity = null;
      }

      if (
        !(
          relationship.type === 'many-to-one' ||
          relationship.type === 'one-to-one'
        ) ||
        relationship.entityA === relationship.entityB
      ) {
        relationship.requiredA = 'no';
      }

      if (relationship.requiredA === 'yes') {
        relationship.relationActionA = null;
      }

      if (
        !(
          relationship.type === 'many-to-one' ||
          relationship.type === 'one-to-one' ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.listA = 'no';
      }

      if (
        !(
          relationship.type === 'many-to-one' ||
          relationship.type === 'one-to-one' ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.filterA = 'no';
      }

      if (
        relationship.entityB === 'membership' ||
        !(
          relationship.type === 'many-to-one' ||
          (relationship.type === 'one-to-one' &&
            relationship.requiredA === 'no') ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.editableA = 'yes';
        relationship.editableB = 'no';
      }

      if (
        relationship.entityB === 'membership' ||
        !(
          relationship.type === 'many-to-one' ||
          relationship.type === 'one-to-one' ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.listB = 'no';
      }

      if (
        relationship.entityB === 'membership' ||
        !(
          relationship.type === 'one-to-one' ||
          relationship.type === 'many-to-one' ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.filterB = 'no';
      }

      if (
        relationship.entityB === 'membership' ||
        !(
          relationship.type === 'one-to-one' ||
          relationship.type === 'many-to-one' ||
          relationship.type === 'many-to-many-implicit'
        )
      ) {
        relationship.exportB = 'no';
      }

      const relationships = state.list;

      const index = relationships.findIndex(
        (current) => current.id === relationship.id,
      );

      if (index > -1) {
        relationships.splice(index, 1, relationship);
      } else {
        relationships.push(relationship);
      }
    },

    new(state) {
      state.current = {
        id: uuid(),
        type: 'many-to-one',
        entityA: '',
        fieldNameA: '',
        fieldLabelA: '',
        editableA: 'yes',
        requiredA: 'no',
        relationActionA: 'nullify',
        listA: 'no',
        filterA: 'no',
        exportA: 'no',
        entityB: '',
        fieldNameB: '',
        fieldLabelB: '',
        relationActionB: 'nullify',
        editableB: 'no',
        listB: 'no',
        filterB: 'no',
        exportB: 'no',
      };
    },

    edit(state, payload) {
      state.current = JSON.parse(JSON.stringify(payload));
    },

    delete(state, payload) {
      const relationships = state.list;

      if (!relationships || !relationships.length) {
        return;
      }

      const index = relationships.findIndex(
        (e) => e.id === payload.id,
      );

      if (index > -1) {
        relationships.splice(index, 1);
      }
    },

    deleteEntity(state, payload) {
      const relationships = state.list;

      if (!relationships || !relationships.length) {
        return;
      }

      let index = 0;

      while (index > -1) {
        index = relationships.findIndex(
          (e) =>
            (e.entityA && e.entityA === payload.id) ||
            (e.entityB && e.entityB === payload.id),
        );

        if (index > -1) {
          relationships.splice(index, 1);
        }
      }
    },

    clear(state) {
      state.current = null;
    },
  },

  actions: {
    new({ commit }) {
      commit('new');
    },

    edit({ commit }, payload) {
      commit('edit', payload);
    },

    clear({ commit }) {
      commit('clear');
    },

    save({ commit, dispatch }) {
      commit('persist');
      dispatch('builder/persistStateToLocalStorage', null, {
        root: true,
      });
    },

    deleteEntity({ commit, dispatch }, payload) {
      commit('deleteEntity', payload);
      return dispatch(
        'builder/persistStateToLocalStorage',
        null,
        { root: true },
      );
    },

    delete({ commit, dispatch }, payload) {
      commit('delete', payload);
      return dispatch(
        'builder/persistStateToLocalStorage',
        null,
        { root: true },
      );
    },
  },
};
